import { reactive, ref } from 'vue';

export interface MessageType {
  type: string;
}

export interface Message {
  type?: 'error' | 'info' | 'success' | 'warning';
  message: string;
}

const showState = reactive({ showFlag: false, requestCount: 0 });

const messageConfirmList = ref<string[]>([]);
const messageList = ref<Message[]>([]);

const confirmType: MessageType = reactive({ type: '' });

export function getMessage(): any {
  return messageList;
}

export function setMessage(message: Message) {
  // メッセージのタイプ('error', 'info', 'success', 'warning' のいずれか)を表示内容の前に置く
  // メッセージが「M-」で始める場合、先頭、「M-.*\t」を削除する
  if (message.message.startsWith('M-')) {
    message.message = message.message.replace(/^M-.*\t/, '');
  }
  // メッセージのタイプに応じて、メッセージの先頭にタイプを追加する
  if (['success', 'info'].includes(message.type || '')) {
    message.message = `[Info:] ${message.message}`;
  } else if (message.type === 'error') {
    message.message = `[Error:] ${message.message}`;
  } else if (message.type === 'warning') {
    message.message = `[Warning:] ${message.message}`;
  }
  messageList.value.push(message);
}

export function setConfirmType(type: string) {
  confirmType.type = type;
}

export function clearMessage() {
  messageConfirmList.value.splice(0);
  messageList.value.splice(0);
}

export function clearDetailMessage(index: number) {
  //指定したメッセージを削除
  messageList.value.splice(index, 1);
}

export function getConfirmMessage() {
  return messageConfirmList;
}

export function setConfirmMessage(message: string) {
  messageConfirmList.value.push(message);
  return new Promise((resolve, reject) => {
    let begin = 0;
    begin = window.setInterval(() => {
      setTimeout(() => {
        if (confirmType.type == 'OK') {
          confirmType.type = '';
          clearInterval(begin);
          return resolve('resolve');
        } else if (confirmType.type == 'CANCEL') {
          confirmType.type = '';
          clearInterval(begin);
          return reject('reject');
        }
      }, 0);
    }, 1000);
  });
}

export function showLoadPage() {
  showState.requestCount++;
  showState.showFlag = true;
}
export function hiddenLoadPage() {
  setTimeout(() => {
    showState.requestCount--;
    if (showState.requestCount == 0) {
      showState.showFlag = false;
    }
  }, 500);
}

export function getShowFlag() {
  return showState;
}
